import React, {Component} from 'react';
import {Button, Modal, Form, Grid, Message} from 'semantic-ui-react';
import MaskedInput from "react-text-mask";
import update from 'react-addons-update';
import moment from "moment/moment";
import 'react-day-picker/lib/style.css';
import {connect} from "react-redux";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import ProductsIngredientsData from "../../data/ProductsIngredientsData";
import {showToast} from "../../actions/ToastAction";
import localDB from "../../data/localDB";
import {otherSaleSelectAction} from "../../actions/OtherSaleSelectAction";
import helpers from "../../functions/helpers";
import {openModalOtherSales} from "../../actions/ModalOtherSalesActions";
import {clientDialog} from "../../actions/ClientDialogAction";
import {selectClient} from "../../actions/ClientSelectActions";
import SaleData from "../../data/SaleData";
const c = require("../../constants");

const moneyMask = createNumberMask({
    prefix: '$',
});

class OtherSaleDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            sale: {
                type: 9,
                payment_method: 1,
                id: null,
                amount: 0,
                notes: '',
                client: null,
                location: props.location
            },
            clients: [],
            date_error: false,
            name_error: false,
            amount_error: false,
            provider_error: false,
            sending: false,
            client_search: '',
            loading: true,
            id: null,
            products_ingredients: []
        };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleDateClick = this.handleDateClick.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleInvoiceNumberChange = this.handleInvoiceNumberChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleObservationsChange = this.handleObservationsChange.bind(this);
        this.handleClientChange = this.handleClientChange.bind(this); 
        this.handleMethodPaymentChange = this.handleMethodPaymentChange.bind(this); 
    }

    componentDidMount() {
        this.initialFetch();
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.select_client && nextProps.select_client.id) {
            setTimeout(() => {
                this.handleSearchClient(null, {searchQuery:nextProps.select_client.id})
                this.handleClientChange(nextProps.select_client.id);
            }, 100);
        }
        if (nextProps.modal.sale && nextProps.modal.sale.id !== this.state.id) {
            this.setState({
                loading: true,
                height: 80,
                id: nextProps.modal.sale.id,
                sale: nextProps.modal.sale,
                location: this.props.location
            });
            if(nextProps.modal.sale.client){
                setTimeout(() => {
                    this.handleSearchClient(null, {searchQuery:nextProps.modal.sale.client})
                    this.handleClientChange(nextProps.modal.sale.client);
                }, 100);
            }
        }
    };

    initialFetch() {
        ProductsIngredientsData.list().then(data => {
            this.setState({products_ingredients: data});
        });
    }

    handleTypeChange = (result) => {
        let type = update(this.state, {
            sale: {
                type: {$set: result},
            }
        });
        this.setState(type);
    };

    handleMethodPaymentChange = (result) => {
        let payment_method = update(this.state, {
            sale: {
                payment_method: { $set: result },
            }
        });
        this.setState(payment_method);
    };

    handleAmountChange = (event) => {
        let value = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '':parseFloat(event.target.value.replace(/\D/g, ''));
        let amount = update(this.state, {
            sale: {
                amount: {
                    $set: value
                }
            }
        });
        this.setState(amount);
        if (event.target.value < 0) {
            this.setState({amount_error: true})
        } else {
            this.setState({amount_error: false});
        }
    };

    handleNameChange = (event) => {
        let name = update(this.state, {
            ingredient: {
                name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(name);
        if (event.target.value.trim() === '') {
            this.setState({name_error: true})
        } else {
            this.setState({name_error: false});
        }
    };

    handleObservationsChange = (event) => {
        let notes = update(this.state, {
            sale: {
                notes: {
                    $set: event.target.value
                }
            }
        });
        this.setState(notes);
    };

    handleInvoiceNumberChange = (event) => {
        let invoice_number = update(this.state, {
            sale: {
                invoice_number: {
                    $set: event.target.value
                }
            }
        });
        this.setState(invoice_number);
    };

    handleDateChange = (event) => {
        let date = update(this.state, {
            sale: {
                date: {
                    $set: event.target.value
                }
            }
        });
        this.setState(date);
        if (event.target.value.trim() === '') {
            this.setState({date_error: true})
        } else {
            this.setState({date_error: false});
        }
    };

    clearForm = () => {
        let type = update(this.state, {
            sale: {
                type: 1,
                id: null,
                amount: 0,
                notes: '',
                client: null,
                location: this.props.location
            }
        });
        this.setState(type);
    };

    handleDateClick = (selectedDay) => {
        let date = update(this.state, {
            sale: {
                date: {
                    $set: moment(selectedDay).format("YYYY-MM-DD")
                }
            }
        });
        this.setState(date);
        this.setState({date_error: false});
    };

    handleClientChange = (result) => {
        let id = result === '0' ? null : result;
        let client = update(this.state, {
            sale: {
                client: {$set: id}
            }
        });
        this.setState(client);
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.sale.amount < 0 || this.state.sale.amount === '') {
            this.setState({amount_error: true});
        } else {
            this.setState({disabled_button: true, sending: true});
            let data = {
                other_sale: true,
                location: this.props.location,
                order: {
                    id: this.state.sale.id,
                    client: this.state.sale.client,
                    amount: this.state.sale.amount,
                    notes: this.state.sale.notes,
                    type: 9,
                },
                payment:{
                    payment: this.state.sale.amount,
                    type: this.state.sale.payment_method
                }
            }
            if (this.props.modal.sale) {
                SaleData.update(data, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.props.otherSaleSelectAction(res);
                        this.props.showToast({message: 'Ingreso Actualizado!', type: 'success'});
                        this.handleClose();
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({disabled_button: false, sending: false});
                });
            } else {
                SaleData.open(data, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.props.otherSaleSelectAction(res);
                        this.props.showToast({message: 'Ingreso Agregado!', type: 'success'});
                        this.handleClose();
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({disabled_button: false, sending: false});
                });
            }
        }
    };

    handleClose = () => {
        this.setState({
            loading: true,
            id: null,
            sending: false,
            sale: {
                date: new Date().toISOString().substring(0, 10),
                type: 9,
                payment_method: 1,
                id: null,
                invoice_number: '',
                amount: 0,
                notes: '',
                provider: null,
                location: this.props.location
            }
        });
        this.props.openModalOtherSales({show: false, sale: null});
    };

    handleAddClient = (e, {value}) => {
        this.props.clientDialog({
            open: true,
            client: {
                full_name: this.state.client_search,
                identification: '',
                phone: '',
                email: '',
                address: '',
                id: null,
                location: this.state.location
            },
        });
    };

    handleSearchClient = (e, value) => {
        localDB.findClients(value.searchQuery).then(data => {
            this.setState({clients: helpers.map_clients(data), client_search:value.searchQuery});
        })
    };

    render() {
        return (
            <Modal
                size='small'
                dimmer='inverted'
                open={this.props.modal.show}
                onClose={this.handleClose}
            >
                <Modal.Header>Agregar Ingreso</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        {this.state.sale.location === 'sales' ? <Message negative header='Información' content='Los ingresos que registres desde aquí no se verán reflejados en el cierre de caja, pero si en los informes y reportes.'/>:null}
                        <Form>
                            <Grid stackable divided>
                                <Grid.Row>
                                    <Grid.Column>
                                        <Form.Select
                                            label='Cliente'
                                            search
                                            lazyLoad={true}
                                            clearable
                                            allowAdditions
                                            additionLabel={<i style={{color: '#00D1C0'}}>Nuevo Cliente: </i>}
                                            options={this.state.clients}
                                            onSearchChange={this.handleSearchClient}
                                            onAddItem={this.handleAddClient}
                                            value={this.state.sale.client ? this.state.sale.client : null}
                                            onChange={(e, {value}) => this.handleClientChange(value)}
                                            placeholder='Cliente'
                                        />
                                        <Form.Input label='Valor'
                                                    onChange={this.handleAmountChange}
                                                    error={this.state.amount_error}
                                                    children={
                                                        <MaskedInput
                                                            mask={moneyMask}
                                                            value={this.state.sale.amount}
                                                            placeholder='Valor'
                                                            onChange={this.handleAmountChange}
                                                        />
                                                    }
                                        />
                                        <Form.Select placeholder='Medio de Pago' label='Medio de Pago'
                                            options={c.PAYMENT_TYPES} value={this.state.sale.payment_method}
                                            onChange={(e, { value }) => this.handleMethodPaymentChange(value)}
                                            error={this.state.payment_method_error} />
                                        <Form.TextArea
                                            label='Concepto'
                                            placeholder='Concepto'
                                            value={this.state.sale.notes}
                                            onChange={this.handleObservationsChange}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    <Button primary icon='save' disabled={this.state.sending}
                            loading={this.state.sending} labelPosition='left' onClick={this.handleSubmit}
                            content={this.props.modal.expense ? 'Actualizar' : 'Guardar'}/>
                </Modal.Actions>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('modal_other_sales'),
        select_client: state.get('select_client'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openModalOtherSales(modal) {
            dispatch(openModalOtherSales(modal))
        },
        showToast(toast) {
            dispatch(showToast(toast))
        },
        clientDialog(client){
            dispatch(clientDialog(client))
        },
        selectClient(client){
            dispatch(selectClient(client))
        },
        otherSaleSelectAction(data) {
            dispatch(otherSaleSelectAction(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OtherSaleDialog)




// WEBPACK FOOTER //
// ./src/components/sale/OtherSaleDialog.js